const i18next = require('i18next')

const STORAGE_KEY = 'coreevent.admin.locale'
const isKeyLike = value => /^[\w-]+(?:[.:][\w-]+)+$/.test(value.trim())
const parameters = value => Array.from(value.matchAll(/{{\s*([^{}]+?)\s*}}/g), match => match[1]).sort()
const interpolate = (value, params) => value.replace(/{{\s*([^{}]+?)\s*}}/g, (token, name) =>
  Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : token)

function createAdminI18n({ messages = {}, storage, enabled = true, onMissing = () => {} } = {}) {
  let locale = 'en'
  try { if (storage && storage.getItem(STORAGE_KEY) === 'hr') locale = 'hr' } catch (_) { /* Storage is optional. */ }
  const resources = { en: { admin: {} }, hr: { admin: {} } }
  Object.keys(messages).forEach(key => {
    const entry = messages[key]
    if (!entry || typeof entry !== 'object') return
    resources.en.admin[key] = Object.prototype.hasOwnProperty.call(entry, 'en') ? entry.en : entry.source
    resources.hr.admin[key] = entry.hr
  })
  const instance = i18next.createInstance()
  instance.init({
    lng: locale, fallbackLng: false, ns: ['admin'], defaultNS: 'admin',
    keySeparator: false, nsSeparator: false, initImmediate: false,
    returnEmptyString: false, returnNull: false,
    interpolation: { escapeValue: false }, resources,
  })

  return {
    get locale() { return enabled ? locale : 'en' },
    setEnabled(next) { enabled = next === true },
    setLocale(next) {
      if (!enabled) return
      locale = next === 'hr' ? 'hr' : 'en'
      instance.changeLanguage(locale)
      try { if (storage) storage.setItem(STORAGE_KEY, locale) } catch (_) { /* Keep the in-memory preference. */ }
    },
    t(key, source, params = {}) {
      // The call-site literal is authoritative: never fall back to a catalog or key.
      if (typeof source !== 'string' || !source.trim() || isKeyLike(source)) {
        throw new Error('Admin translation requires original human-readable fallback text')
      }
      if (!enabled) return interpolate(source, params)
      // Existing English copy keeps its authoritative literal fallback. Explicit
      // English resources support screens whose original copy was Croatian.
      if (locale === 'en' && !Object.prototype.hasOwnProperty.call(messages[key] || {}, 'en')) return interpolate(source, params)
      const result = instance.t(key, { ...params, returnDetails: true })
      const translated = result.res
      const resourceKey = result.exactUsedKey || key
      const raw = instance.getResource(locale, 'admin', resourceKey)
      const valid = typeof raw === 'string' && raw.trim() && !isKeyLike(raw) &&
        JSON.stringify(parameters(raw)) === JSON.stringify(parameters(source)) &&
        typeof translated === 'string' && translated.trim() && !isKeyLike(translated) &&
        !translated.includes('{{') && !translated.includes('}}')
      if (valid) return translated
      onMissing(key)

      return interpolate(source, params)
    },
  }
}

module.exports = { createAdminI18n, isKeyLike, parameters }
